<template lang="html">
  <div>
    <div class="row g-0 pt-3" v-if="create==false">
      <div class="col-auto sw-3 d-flex flex-column justify-content-center align-items-center position-relative me-4">
        <div class="rounded-xl shadow d-flex flex-shrink-0 justify-content-center align-items-center">
          <img v-if="avatar_url != null" :src="avatar_url" class="img-fluid rounded-xl" alt="thumb">
          <i class="fa fa-2x fa-user-tie" v-else="v-else"></i>
        </div>
        <div class="w-100 d-flex h-100 justify-content-center position-relative">
          <div class="line-w-1 bg-separator h-100 position-absolute"></div>
        </div>
      </div>
      <div class="col mb-4">
        <div class="h-100">
          <div class="d-flex flex-column justify-content-start">
            <div class="d-flex flex-column">
              <div class="heading mb-0">{{ context.who }}</div>
              <div class="text-muted small">{{ human_posted_on }}</div>
              <div>
                <div class="text-alternate mt-1" v-if="context.who != $store.state.profile.data.fullname">
                  <span v-html="text_html(context.text)"></span>
                </div>

                <div v-else>
                  <textarea class="textarea" v-if="comment_editable === true" style="border: none;"
                            v-model="context.text"></textarea>
                  <button class="btn btn-outline-primary" style="min-width: 110px;" v-if="comment_editable === true"
                          @click="save_comment">Enregistrer
                  </button>

                  <span v-if="comment_editable === false">
                                    <span v-html="text_html(context.text)" style="display: inline;"></span>&nbsp;
                                    <a href="#" @click="edit_comment" style="display: inline;">
                                        <i class="icon-14 bi bi-pencil"></i>
                                    </a>
                                </span>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else="v-else">
      <form class="row gx-3 gy-2 align-items-center d-flex align-items-center">
        <div class="input-group ">
          <textarea style="resize: both;" class="form-control" :ref="'comment_input'" v-model="this_text"
                    placeholder="Votre message..." :disabled="disabled" aria-describedby="button-area"
                    rows="2"></textarea>
          <button class="btn btn-outline-primary" type="button" id="button-area" style="min-width: 110px;"
                  v-if="create == true" @click="send" :disabled="this_text=='' || disabled">Poster
          </button>
        </div>

      </form>
    </div>
  </div>
</template>

<script>
import tools from "@/tools.js";
import moment from "moment";
import settings from "@/settings.coffee";

export default {
  name: "Comment",
  props: {
    content: Object,
    disabled: {
      type: Boolean,
      default: false
    },
    isAnswerWriting: {
      type: Boolean,
      default: false
    }
  },
  filters: {
    remove_newline(txt) {
      if (txt) {
        return txt.replace("\\n", " ");
      }
      return txt;
    },
    fix_newline(txt) {
      if (txt) {
        return txt.replace("\\n", "\n");
      }
      return txt;
    }
  },
  data() {
    return {
      create: true,
      context: null,
      this_text: "",
      comment_editable: false
    };
  },
  computed: {
    human_posted_on() {
      return this.context && this.context.posted_on
        ? moment(this.context.posted_on).fromNow()
        : "";
    },
    avatar_url() {
      if (
        this.context &&
        this.context.who ===
          (this.$store.state.profile &&
            this.$store.state.profile.data &&
            this.$store.state.profile.data.fullname)
      ) {
        if (this.content && this.content.avatar) {
          return (
            settings.backendUrl +
            (this.$store.state.profile &&
              this.$store.state.profile.data &&
              this.$store.state.profile.data.avatar
              ? this.$store.state.profile.data.avatar
              : "")
          );
        } else {
          return null;
        }
      } else {
        if (this.content && this.content.avatar) {
          return settings.backendUrl + this.content.avatar;
        } else {
          return null;
        }
      }
    }
  },
  methods: {
    text_html(text) {
      return text ? text.replace(/(?:\r\n|\r|\n)/g, "<br>") : "";
    },
    get_uid() {
      return (
        (this.context && this.context.posted_on
          ? String(this.context.posted_on)
          : "") +
        "_" +
        (this.context && this.context.who ? this.context.who : "")
      );
    },
    edit_comment() {
      this.comment_editable = true;
    },
    save_comment() {
      this.comment_editable = false;
      const data = tools.deep_copy(this.context);
      this.$emit("comment:update", tools.deep_copy(this.context));
    },
    send() {
      // create a new comment
      if (this.context) {
        this.context.posted_on = moment().toDate();
        this.context.text = this.this_text.replace(/(?:\r\n|\r|\n)/g, "<br>");
        this.$emit("comment:send", tools.deep_copy(this.context));
        this.this_text = "";
        this.$store.commit("delete_edited_fields", {
          key: "comment"
        });
      }
    }
  },
  created() {
    this.this_text = this.content && this.content.text ? this.content.text : "";
    this.context = this.content;

    if (!this.content || this.content.text == null) {
      this.create = true;
    } else {
      this.context.text = this.context.text.replace(/<br>/g, "\n");
      this.create = false;
    }
  },
  watch: {
    this_text(newV, oldV) {
      if (this.$refs && this.$refs.comment_input) {
        this.$store.commit("update_edited_fields", {
          key: "comment",
          value: newV,
          verbose_name: "Commentaire",
          el: this.$refs.comment_input
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.talk-bubble {
  margin: 5px;
  display: inline-block;
  position: relative;
  width: 100%;
  height: auto;
  background-color: white;
}

.timeline-content {
  padding-right: 30px !important;
}

.border {
  border: 8px solid #666;
}

.round {
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;

}

.tri-right.border.left-top:before {
  content: ' ';
  position: absolute;
  width: 0;
  height: 0;
  left: -40px;
  right: auto;
  top: -8px;
  bottom: auto;
  border: 32px solid;
  border-color: #666 transparent transparent transparent;
}

.tri-right.left-top:after {
  content: ' ';
  position: absolute;
  width: 0;
  height: 0;
  left: -20px;
  right: auto;
  top: 0px;
  bottom: auto;
  border: 22px solid;
  border-color: white transparent transparent transparent;
}

.talktext {
  padding: 1em;
  text-align: left;
  line-height: 1.5em;
}

.talktext p {
  /* remove webkit p margins */
  -webkit-margin-before: 0em;
  -webkit-margin-after: 0em;
}
</style>
